module.exports = "pegasus/assets/themelp1/basic/104.png";